<template>
  <div>
    <v-row class="d-flex justify-start mt-7">
      <v-btn color="primary" class="text-capitalize ml-7 mt-1" dark @click="dialog = true">
        <v-icon class="mr-2" size="23">mdi-file-document-plus-outline</v-icon>
        <span class="text-body-2">Crear HCP</span>
      </v-btn>
      <v-btn color="primary" class="text-capitalize ml-7 mr-5 mt-1" dark @click="dialog3 = true">
        <v-icon class="mr-2" size="23">mdi-swap-horizontal</v-icon>
        <span class="text-body-2">Transferir</span>
      </v-btn>
      <v-btn color="primary" class="text-capitalize ml-2 mr-5 mt-1" dark @click="dialog4 = true">
        <v-icon class="mr-2" size="23">mdi-axis-y-arrow</v-icon>
        <span class="text-body-2">Asimilar</span>
      </v-btn>
      <v-dialog v-model="dialog" persistent max-width="580px">
        <v-card rounded="xl">
          <v-card-title class="d-flex text-body-1 justify-center">
            <span class="mt-8">NUEVO HCP</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <p class="text-body-2">
                Se creará una Historia Clínica Psicológica:
              </p>
              <p class="text-body-2">
                ⚫︎ La sección de Condición Actual [CA] será a partir de una plantilla vacía.
              </p>
              <p class="text-body-2">
                ⚫︎ La sección de Antecedentes [AN] puede crearse apartir de:
              </p>
              <v-checkbox
                v-model="checkboxFormEmptyLocal"
                @change="handleEventsbox"
                label="Una plantilla vacía:"
                hide-details
                class="ml-5 small-label"
              ></v-checkbox>
              <v-row class="mt-5">
                <v-col cols="12" class="justify-center">
                  <span class="text-body-2 ml-4">
                    O a partir de la clonación de los Antecedentes de algún HCP:
                  </span>
                  <v-data-table
                    v-model="selectedLocal"
                    :headers="schema.headersVersionAN"
                    :items="filteredDataCrud"
                    item-key="clinicalHistories_hcp"
                    :items-per-page=10
                    :sort-by="['clinicalHistories_hcp']"
                    :sort-desc="[true]"
                    :single-select="true"
                    show-select
                    class="elevation-1"
                  />
                  <span class="text-body-2 ml-3">
                    * Podrá crear una nueva HCP cada 2 meses.
                  </span>
                </v-col>
              </v-row>
              <v-row class="mt-6 justify-center">
                <v-col cols="5" class="justify-center" @click="dialog = false">
                  <v-btn block color="primary" @click="createHCP"> CREAR </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog3" persistent width="650">
        <v-card>
          <v-card-title class="d-flex text-body-1 justify-center">
            <span class="mt-8">Transferencia de una HCP</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <p class="text-body-2">
                Puede agregar una Historia Clínica Psicológica a partir de una transferencia
                realizada por el paciente. Solicite al paciente que realice esta operación desde su
                propia cuenta.
              </p>
              <span>
                Complete la transferencia ingresando el código brindado por el paciente.
              </span>
              <v-row class="mt-2 justify-center">
                <v-col cols="5" class="justify-center">
                  <v-text-field
                    v-model="codeTransfer"
                    placeholder="Código de Transferencia"
                    outlined
                    dense
                    @input="codeTransferInput"
                    @change="codeTransferInput"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-3 justify-center">
                <v-col cols="4" class="justify-center">
                  <v-btn block color="primary" @click="(dialog3 = false), transfer()">
                    COMPLETAR
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog3 = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog4" persistent width="650">
        <v-card>
          <v-card-title class="d-flex text-body-1 justify-center">
            <span class="mt-8">Asimilar HCP's de Paciente</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <p class="text-body-2">
                Permite asimilar las Historias Clínicas Psicológicas de una NPat sin cuenta hacia otra Npat verificada por el paciente.
                Solicite al paciente que confirme esta operación desde su propio correo.
              </p>
              <v-row class="mt-2 justify-center">
                <v-col cols="4" class="justify-center">
                  <v-text-field
                    v-model="assimilateNPatNoCountLocal"
                    placeholder="NPat Sin Cuenta"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="1" class="d-flex justify-center pt-0 mx-2">
                  <v-icon class="mx-2 mt-2" size="50">mdi-ray-start-arrow</v-icon>
                </v-col>
                <v-col cols="4" class="justify-center">
                  <v-text-field
                    v-model="assimilateNPatVerifLocal"
                    placeholder="NPat Verificada"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-7 justify-center">
                <v-col cols="4" class="justify-center">
                  <v-btn block color="primary" @click="(dialog4 = false), assimilate()">
                    ASIMILAR
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog4 = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog5" persistent width="1100">
        <v-card>
          <v-card-title class="d-flex text-body-1 justify-center">
            <span class="mt-10">HCP vs Prueba</span>
          </v-card-title>
          <v-table-pro-patient-versus
            :headersHCPvsTest="headersHCPvsTest"
            :dataHCPvsTest="dataHCPvsTest"
          />
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog5 = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import VTableProPatientVersus from '@/components/base/VTableProPatientVersus.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'VDialogsPatC',

  components: {
    VTableProPatientVersus,
  },

  props: [
    'headersHCPvsTest',
    'dataHCPvsTest',
    'cloneHCP',
    'createHCP',
    'selected',
    'checkboxFormEmpty',
    'handleEventsbox',
    'transfer',
    'assimilate',
    'codeTransferInput',
    'assimilateNPatNoCount',
    'assimilateNPatVerif',
  ],

  data() {
    return {
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      codeTransfer: '',
    };
  },

  watch: {
    value: {
      handler(after) {
        this.codeTransfer = after;
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters('proPatientsCPage', ['dataCrud', 'schema']),

    checkboxFormEmptyLocal: {
      get() {
        return this.checkboxFormEmpty;
      },
      set(value) {
        this.$emit('update:checkboxFormEmpty', value);
      },
    },

    selectedLocal: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit('update:selected', value);
      },
    },

    assimilateNPatNoCountLocal: {
      get() {
        return this.assimilateNPatNoCount;
      },
      set(value) {
        this.$emit('update:assimilateNPatNoCount', value);
      },
    },

    assimilateNPatVerifLocal: {
      get() {
        return this.assimilateNPatVerif;
      },
      set(value) {
        this.$emit('update:assimilateNPatVerif', value);
      },
    },

    filteredDataCrud() {
      return this.dataCrud.filter(item => {
        return item.permission_HCP !== '🔒 Sin acceso';
      });
    }
  }
};
</script>

<style>
.small-label .v-label {
  font-size: 15px !important;
  line-height: 16px;
}
</style>